import { Injectable, Injector, inject } from '@angular/core';
import { RouterPreloader } from '@angular/router';
import { finalize } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoutePreloadIntentService {
    //#region Dependency injection
    private readonly injector = inject(Injector);
    //#endregion

    //#region State
    private readonly requestedKeys = new Set<string>();
    private preloadInFlight = false;
    private preloadQueued = false;
    //#endregion

    //#region Public methods
    request(key: string): void {
        const preloadKey = key.trim();
        if (!preloadKey || this.requestedKeys.has(preloadKey)) return;

        this.requestedKeys.add(preloadKey);
        this.runPreload();
    }

    hasRequested(key: string): boolean {
        return this.requestedKeys.has(key.trim());
    }
    //#endregion

    //#region Private methods
    private runPreload(): void {
        if (this.preloadInFlight) {
            this.preloadQueued = true;
            return;
        }

        this.preloadInFlight = true;
        this.injector
            .get(RouterPreloader)
            .preload()
            .pipe(finalize(() => this.onPreloadFinished()))
            .subscribe({ error: () => undefined });
    }

    private onPreloadFinished(): void {
        this.preloadInFlight = false;

        if (!this.preloadQueued) return;

        this.preloadQueued = false;
        this.runPreload();
    }
    //#endregion
}
